module.exports = __webpack_public_path__ + "img/zhlc-4.67c1ed52.png";